import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SectionCertificationContainerService {
  public mapCertificationsData(data: any): any {
    return {
      img: data.img && data.img.iv && data.img.iv[0] ? data.img.iv[0].url : '',
      subtitle: data.subtitle ? data.subtitle.iv : '',
      title: data.title ? data.title.iv : ''
    };
  }
}
